import React from "react"
import styled from "styled-components"
import breakpoints from "@constants/breakpoints"
import ExploreSmallCard, {
  ExploreSmallCardProps,
} from "@components/ExploreSmallCard"
import {
  Container as CommonContainer,
  TitleWrapper,
  Title,
  Subtitle,
  Cards,
  CardWrapper,
  ButtonWrapper,
  Button,
} from "./common"
import { MobileAndDesktopOnly, TabletOnly } from "@utils/MediaQuery"
import * as R from "ramda"

const Container = styled(CommonContainer)`
  ${Title} {
    @media ${breakpoints.laptop} {
      margin-bottom: 42px;
    }
  }

  ${Cards} {
    padding-bottom: 24px;

    @media ${breakpoints.tablet} {
      flex-wrap: wrap;
    }
  }

  ${CardWrapper} {
    @media ${breakpoints.tablet} {
      margin-bottom: 36px;
    }
  }
`

interface SmallCardsProps {
  blockId?: string
  title: string
  subtitle?: string
  cards: Array<ExploreSmallCardProps>
  actionText: string
  actionLink: string
  titleColSize?: number
}

const SmallCards: React.FC<SmallCardsProps> = ({
  blockId,
  title,
  subtitle,
  cards,
  actionText,
  actionLink,
  titleColSize = 3,
}) => {
  const firstThreeCards = R.take(3, cards)
  return (
    <Container id={blockId || undefined}>
      <TitleWrapper>
        <Title titleColSize={titleColSize}>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </TitleWrapper>
      <MobileAndDesktopOnly>
        <Cards>
          {firstThreeCards.map((card, i) => (
            <CardWrapper key={`${i}-${card.link}`}>
              <ExploreSmallCard {...card} />
            </CardWrapper>
          ))}
        </Cards>
      </MobileAndDesktopOnly>
      <TabletOnly>
        <Cards>
          {cards.map((card, i) => (
            <CardWrapper key={`tablet-${i}-${card.link}`}>
              <ExploreSmallCard {...card} />
            </CardWrapper>
          ))}
        </Cards>
      </TabletOnly>
      <ButtonWrapper>
        <Button to={actionLink} text={actionText} />
      </ButtonWrapper>
    </Container>
  )
}

export default SmallCards
